export class StatusController {
	constructor(statusNode) {
		this.statusNode = statusNode;
	}

	setStatus(message) {
		if (!this.statusNode) {
			return;
		}

		this.statusNode.textContent = message;
		this.statusNode.classList.remove('is-error');
	}

	setStatusError(message) {
		if (!this.statusNode) {
			return;
		}

		this.statusNode.textContent = message;
		this.statusNode.classList.add('is-error');
	}

	isStatusErrorActive() {
		if (!this.statusNode) {
			return false;
		}

		return this.statusNode.classList.contains('is-error');
	}
}
